import React, { Component } from 'react'

import cn from 'classnames'
import s from './SimpleTable.scss'

export default class SimpleTable extends Component {
  render() {
    const { className, children, style } = this.props
    return (
      <div className={cn(s.table, className)} style={style}>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Tables/SimpleTable/SimpleTable.jsx